module.exports = __webpack_public_path__ + "static/media/t5.3606ec0e.jpg";